import React from 'react'
import Info from './info.js';
//import './FilterForm.css'
import {localestr} from '../utils.js'
import EditCtrl from './EditCtrl.js'

function FilterForm({curData,setValue,save,close,catEmployees,salaryData}){
    let posX = 0, posY = 0
    function dragMouseDown(e) {
      e = e || window.event;
      posX = e.clientX;
      posY = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
    function elementDrag(e) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd_salary')
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - e.clientX;
        pos2 = posY - e.clientY;
        posX = e.clientX;
        posY = e.clientY;
        // set the element's new position:
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        if(new_top>window.innerHeight-30) new_top=window.innerHeight-30
        if (pos2!==0) elmnt.style.top = new_top + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
        document.ontouchend = null;
        document.ontouchcancel = null;
        document.ontouchmove = null;
    }
    function dragTouchDown(e) {
        e = e || window.event;
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        document.ontouchend = closeDragElement;
        document.ontouchcancel = closeDragElement;
        document.ontouchmove = touchDrag;
    }
    function touchDrag(e) {
        let pos1 = 0, pos2 = 0
        const elmnt=document.getElementById('wnd_salary')
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = posX - parseInt(e.changedTouches[0].clientX)
        pos2 = posY - parseInt(e.changedTouches[0].clientY)
        posX = parseInt(e.changedTouches[0].clientX)
        posY = parseInt(e.changedTouches[0].clientY)
        let new_top=elmnt.offsetTop - pos2
        if(new_top<0) new_top=0
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = new_top + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    let user=localestr(' користувача')
    let dep1=''
    let dep2=''
    let arr_d1=[]
    let ttl_d1=0
    let arr_d2=[]
    let ttl_d2=0
    let arr_tt=[]
    let ttl_tt=0
    if(catEmployees&&curData.employee){
        const empl=catEmployees.find(el=>el.id===curData.employee.id)
        if(empl){
            user=' '+((empl.author||{name:''}).name||'')
            dep1=' '+((empl.department1||{name:''}).name||'')
            dep2=' '+((empl.department2||{name:''}).name||'')
            if(salaryData&&salaryData.sales){
                const dates=salaryData.dates
                salaryData.sales.forEach(c => {
                    if(dates.findIndex(it=>it===empl.id+'&&'+c.date)!==-1&&c.department_id===empl.department1.id){
                        const idx=arr_d1.findIndex(el=>el.date===c.date)
                        if(idx===-1) arr_d1.push({date:c.date,amount:parseFloat(c.amount)||0})
                        else arr_d1[idx].amount+=parseFloat(c.amount)||0
                        ttl_d1+=parseFloat(c.amount)||0
                    }
                    if(dates.findIndex(it=>it===empl.id+'&&'+c.date)!==-1&&c.department_id===empl.department2.id){
                        const idx=arr_d2.findIndex(el=>el.date===c.date)
                        if(idx===-1) arr_d2.push({date:c.date,amount:parseFloat(c.amount)||0})
                        else arr_d2[idx].amount+=parseFloat(c.amount)||0
                        ttl_d2+=parseFloat(c.amount)||0
                    }
                    if(dates.findIndex(it=>it===empl.id+'&&'+c.date)!==-1&&c.department_id===empl.department2.id) arr_d2.push({date:c.date,amount:c.amount})
                    if(dates.findIndex(it=>it===empl.id+'&&'+c.date)!==-1) {
                        const idx=arr_tt.findIndex(el=>el.date===c.date)
                        if(idx===-1) arr_tt.push({date:c.date,amount:parseFloat(c.amount)||0})
                        else arr_tt[idx].amount+=parseFloat(c.amount)||0
                        ttl_tt+=parseFloat(c.amount)||0
                    }
                })
            }
        }
    }

    let i_dep1=null
    if(arr_d1.length){
        i_dep1=<Info info={<table style={{border:'none',borderCollapse:'collapse',textAlign:'center'}}><caption>{localestr('Виручка по підрозділу')}</caption><tbody>
        {arr_d1.map((el,i)=><tr key={i}><td style={{border:'none'}}>{(new Date(el.date)).toLocaleDateString()}</td><td style={{border:'none',width:'90px',textAlign:'right'}}>{el.amount.toFixed(2)}</td></tr>)}
        <tr><td style={{border:'none',fontWeight:'bold'}}>{localestr('Разом')}</td><td style={{border:'none',width:'90px',textAlign:'right',fontWeight:'bold'}}>{ttl_d1.toFixed(2)}</td></tr>
        </tbody></table>} />
    } else i_dep1=<div style={{minWidth:'21px',display:'inline-block',flexGrow:0,maxWidth:'21px'}}></div>
    let i_dep2=null
    if(arr_d2.length){
        i_dep2=<Info info={<table style={{border:'none',borderCollapse:'collapse',textAlign:'center'}}><caption>{localestr('Виручка по підрозділу')}</caption><tbody>
        {arr_d2.map((el,i)=><tr key={i}><td style={{border:'none'}}>{(new Date(el.date)).toLocaleDateString()}</td><td style={{border:'none',width:'90px',textAlign:'right'}}>{el.amount.toFixed(2)}</td></tr>)}
        <tr><td style={{border:'none',fontWeight:'bold'}}>{localestr('Разом')}</td><td style={{border:'none',width:'90px',textAlign:'right',fontWeight:'bold'}}>{ttl_d2.toFixed(2)}</td></tr>
        </tbody></table>} />
    } else i_dep2=<div style={{minWidth:'21px',display:'inline-block',flexGrow:0,maxWidth:'21px'}}></div>
    let i_ttl=null
    if(arr_tt.length){
        i_ttl=<Info info={<table style={{border:'none',borderCollapse:'collapse',textAlign:'center'}}><caption>{localestr('Виручка по підрозділу')}</caption><tbody>
        {arr_tt.map((el,i)=><tr key={i}><td style={{border:'none'}}>{(new Date(el.date)).toLocaleDateString()}</td><td style={{border:'none',width:'90px',textAlign:'right'}}>{el.amount.toFixed(2)}</td></tr>)}
        <tr><td style={{border:'none',fontWeight:'bold'}}>{localestr('Разом')}</td><td style={{border:'none',width:'90px',textAlign:'right',fontWeight:'bold'}}>{ttl_tt.toFixed(2)}</td></tr>
        </tbody></table>} />
    } else i_ttl=<div style={{minWidth:'21px',display:'inline-block',flexGrow:0,maxWidth:'21px'}}></div>

    return(
        <div className='modal_f'><div className='window' id={'wnd_salary'}>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}} onMouseDown={dragMouseDown} onTouchStart={dragTouchDown}>
                <div className='caption'>{localestr('Нарахування')}</div><div className='closebtn' onClick={close}/>
            </div>
            <div className='content' style={{overflow:'visible'}}>

            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Працівник')} Value={curData.employee} typeVal={'catEmployees'} setVal={(d)=>{setValue('employee',d)}} width1='80' width2='195' />
                <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Відпрацьовано днів')} Value={curData.days} typeVal={'number'} setVal={(d)=>{setValue('days',d)}} width1='150' width2='50' />
                <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('годин')} Value={curData.hours} typeVal={'number'} setVal={(d)=>{setValue('hours',d)}} width1='45' width2='55' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Нараховано оклад')} Value={curData.sum_m} typeVal={'number'} setVal={(d)=>{setValue('sum_m',d)}} width1='140' width2='92' />
                <div style={{minWidth:'13px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('поденно')} Value={curData.sum_d} typeVal={'number'} setVal={(d)=>{setValue('sum_d',d)}} width1='67' width2='92' />
                <div style={{minWidth:'13px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('погодинно')} Value={curData.sum_h} typeVal={'number'} setVal={(d)=>{setValue('sum_h',d)}} width1='82' width2='92' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Виручка')+user} Value={curData.amount_a} typeVal={'number'} setVal={(d)=>{setValue('amount_a',d)}} width1='279' width2='106' />
                <div style={{minWidth:'21px',display:'inline-block',flexGrow:0,maxWidth:'21px'}}></div>
                <div style={{minWidth:'10px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Нараховано')} Value={curData.sum_a} typeVal={'number'} setVal={(d)=>{setValue('sum_a',d)}} width1='90' width2='85' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Виручка підрозділа')+dep1} Value={curData.amount_d1} typeVal={'number'} setVal={(d)=>{setValue('amount_d1',d)}} width1='279' width2='106' />
                {i_dep1}<div style={{minWidth:'10px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Нараховано')} Value={curData.sum_d1} typeVal={'number'} setVal={(d)=>{setValue('sum_d1',d)}} width1='90' width2='85' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Виручка підрозділа')+dep2} Value={curData.amount_d2} typeVal={'number'} setVal={(d)=>{setValue('amount_d2',d)}} width1='279' width2='106' />
                {i_dep2}<div style={{minWidth:'10px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Нараховано')} Value={curData.sum_d2} typeVal={'number'} setVal={(d)=>{setValue('sum_d2',d)}} width1='90' width2='85' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Загальна виручка закладу')} Value={curData.amount_t} typeVal={'number'} setVal={(d)=>{setValue('amount_t',d)}} width1='279' width2='106' />
                {i_ttl}<div style={{minWidth:'10px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
                <EditCtrl Capt={localestr('Нараховано')} Value={curData.sum_t} typeVal={'number'} setVal={(d)=>{setValue('sum_t',d)}} width1='90' width2='85' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('Премія')} Value={curData.bonus} typeVal={'number'} setVal={(d)=>{setValue('bonus',d)}} width1='57' width2='85' />
                <div style={{minWidth:'58px',display:'inline-block'}}></div>
                <EditCtrl Capt={localestr('Лікарняні')} Value={curData.sick} typeVal={'number'} setVal={(d)=>{setValue('sick',d)}} width1='73' width2='85' />
                <div style={{minWidth:'58px',display:'inline-block'}}></div>
                <EditCtrl Capt={localestr('Відпускні')} Value={curData.vacation} typeVal={'number'} setVal={(d)=>{setValue('vacation',d)}} width1='70' width2='85' />
            </div>
            <div style={{minWidth:'565px',display:'inline-block',textAlign:'right',fontWeight:'bold'}}>{localestr('Разом нараховано')+' '+(curData.totall||'0.00')}</div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('База для податків')} Value={curData.tax_base} typeVal={'number'} setVal={(d)=>{setValue('tax_base',d)}} width1='133' width2='85' />
                <div style={{minWidth:'8px',display:'inline-block'}}></div>
                <EditCtrl Capt={localestr('ПДФО')} Value={curData.inc_tax} typeVal={'number'} setVal={(d)=>{setValue('inc_tax',d)}} width1='48' width2='85' />
                <div style={{minWidth:'8px',display:'inline-block'}}></div>
                <EditCtrl Capt={localestr('Військовий збір')} Value={curData.mil_tax} typeVal={'number'} setVal={(d)=>{setValue('mil_tax',d)}} width1='119' width2='85' />
            </div>
            <div style={{margin:'2px 0',display:'inherit'}}>
                <EditCtrl Capt={localestr('ЄСВ')} Value={curData.esv} typeVal={'number'} setVal={(d)=>{setValue('esv',d)}} width1='32' width2='85' />
                <div style={{minWidth:'8px',display:'inline-block'}}></div>
                <EditCtrl Capt={localestr('Всі податки у витрати')} Value={curData.expenses} typeVal={'l_check'} setVal={(d)=>{setValue('expenses',d)}} width1='197' width2='20'/>
                <div style={{minWidth:'224px',display:'inline-block',textAlign:'right',fontWeight:'bold'}}>{localestr('Разом податки')+' '+(curData.taxes||'0.00')}</div>
            </div>
            <div style={{minWidth:'565px',display:'inline-block',textAlign:'right',fontWeight:'bold'}}>{localestr('До виплати')+' '+(curData.amount||'0.00')}</div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={save}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={close}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default FilterForm